var auth = {
  getAuthorization () {
    return localStorage.getItem('Authorization');
  },
  setAuthorization (Authorization) {
    localStorage.setItem('Authorization', Authorization);
  },
  clearAuthorization () {
    localStorage.removeItem('Authorization');
  }
}

export default {
  install: function (vue) {
    vue.prototype.$auth = auth
  }
}
